import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import FeaturedSection from "./components/FeaturedSection";
import TestimonialSection from "./components/TestimonialSection";
import ArticlePreviewSection from "./components/ArticlePreviewSection";
import ArticlesListSection from "./components/ArticlesListSection";
import Footer from "@/components/feature/Footer";

const SITE_DOMAIN = import.meta.env.VITE_SITE_URL as string;

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Kakobuy Yachts",
  "url": SITE_DOMAIN,
  "description": "Kompletny przewodnik po Kakobuy Spreadsheet dla użytkowników z Polski",
  "inLanguage": "pl-PL",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${SITE_DOMAIN}/?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Kakobuy Yachts",
  "url": SITE_DOMAIN,
  "description": "Polski przewodnik po zakupach z Chin — Kakobuy Spreadsheet, rankingi, porady QC i wysyłka do Polski.",
  "foundingDate": "2025",
  "inLanguage": "pl-PL",
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "availableLanguage": ["Polish", "English"],
  },
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Strona główna",
      "item": SITE_DOMAIN,
    },
  ],
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <FeaturedSection />
        <TestimonialSection />
        <ArticlePreviewSection />
        <ArticlesListSection />
      </main>
      <Footer />

      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  );
}